import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods, ContentTypes } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { IAddressElement } from '../../../components/accounts/modal/paymentAndBilling/address';
import { Features, isFeatureEnabled } from '../../../featureToggles/features/index';
import { showSuccessMessage, showErrorMessage } from '../../notifications';
import { actions as AccountListActions } from '../list';

export interface IArgsPaymentAndBilling {
  accountId: string;
  sampleDiscountPercentage: number;
  paymentOptions: Array<string>;
  billingAddress?: IAddressElement;
  // use for Features.PlgExternal
  priceOfNewLicenses?: number;
  invoiceTerms?: string;
  purchaseOrderNumber?: string;
  sendInvoice?: boolean;
  // end of use for Features.PlgExternal
  // use in Features.BillingUserFacing
  carbonCopyRecipients?: string[];
  // end of use in Features.BillingUserFacing
  dealAmount?: number;
}
export const PAYMENT_AND_BILLING_THUNK_PREFIX = 'paymentAndBilling';
export const createPaymentAndBilling: AsyncThunk<void, IArgsPaymentAndBilling,ThunkAPI> = createAsyncThunk(
  PAYMENT_AND_BILLING_THUNK_PREFIX,
  async (info: IArgsPaymentAndBilling, thunk) => {
    const { sendInvoice, ...data } = info;
    const dealAmount = data.dealAmount;
    try {
      delete data.carbonCopyRecipients;
      delete data.dealAmount;

      const response = await basicApiAsyncThunkCreator<void, IArgsPaymentAndBilling>({
        endpoint: 'accounts/payment-and-billing',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: ContentTypes.ApplicationJson
      })(data, thunk);
      const sendInvoiceMessage = isFeatureEnabled(Features.DealZero) && dealAmount === 0
        ? 'The process was successfully completed!'
        : 'An invoice has been sent successfully.';
      const successMessage = sendInvoice ? sendInvoiceMessage : 'Billing address updated successfully.';
      thunk.dispatch(showSuccessMessage(successMessage));
      thunk.dispatch(AccountListActions.updateAccountBillingInfo(data));
      return response;
    } catch(err) {
      if (isFeatureEnabled(Features.PlgExternal)) {
        thunk.dispatch(showErrorMessage('An error occurred while updating Billing Address'));
      }
      return thunk.rejectWithValue(JSON.stringify(err) || 'An error occurred on createPaymentAndBilling');
    }
  }
);
